import { VALIDATION_TEMPLATE } from './validationTemplete';

export const LOGIN_VALIDATION = {
  FIELDS: ['employeeCode', 'password'],
  MESSAGE: {
    employeeCode: {
      required: VALIDATION_TEMPLATE.required('社員コード'),
      isHalfWidth: VALIDATION_TEMPLATE.isHalfWidth('社員コード'),
    },
    password: {
      required: VALIDATION_TEMPLATE.required('パスワード'),
      pattern: VALIDATION_TEMPLATE.password(),
    },
  },
  RULES: {
    employeeCode: {
      required: true,
      isHalfWidth: /^[\x20-\x7E]+$/, // 半角
    },
    password: {
      required: true,
      pattern: /^[a-zA-Z0-9]{8,}$/, // 英数字8文字以上
    },
  },
};
